<template>
  <div class="pb-12" @mousemove="mouseMoved" @mouseup="dropIntervention">
    <project-modal v-if="isNewProjectModalOpened" @close="isNewProjectModalOpened = false" @submitted="projectCreated" />
    <project-intervention-modal :intervention="openedIntervention" v-if="isInterventionOpened" @close="isInterventionOpened = false" @submitted="interventionUpdated" />
    <v-row no-gutters justify="center" align="start">
      <div class="n-container">
        <v-row no-gutters justify="start" align="start">
          <v-col align="center" class="pa-0 mx-6">
            <v-row no-gutters align="center" class="content-header">
              <!-- <v-expand-x-transition>
                <div v-show="!areFiltersOpened">
                  <v-btn class="n-white-btn n-small-btn px-2 mr-2" @click="areFiltersOpened = true">
                    <v-icon small class="mr-2">filter_list</v-icon>
                    Filtrer
                  </v-btn>
                </div>
              </v-expand-x-transition> -->
              <span class="font-weight-bold">Plan de charge</span>
              <v-spacer></v-spacer>
              <v-btn class="n-white-btn n-small-btn n-icon-btn" @click="previousWeek">
                <v-icon>chevron_left</v-icon>
              </v-btn>
              <div class="ml-1" v-if="false">
                <v-select
                  :items="sorts"
                  v-model="sort"
                  single-line
                  solo
                  hide-details
                  item-text="label"
                  item-value="id"
                  flat
                  height="36px"
                  pprepend-inner-icon="visibility"
                  class="n-select workload-action-select pl-2"
                ></v-select>
              </div>
              <v-btn class="n-white-btn n-small-btn n-icon-btn ml-1" @click="nextWeek">
                <v-icon>chevron_right</v-icon>
              </v-btn>
              <!-- <pager @change="fetchInterventions()" /> -->
              <!-- <v-btn class="n-white-btn n-small-btn n-icon-btn ml-2" @click="forceFetchInterventions">
                <v-icon>refresh</v-icon>
              </v-btn> -->
              <v-btn color="primary darken-1" class="n-primary-btn n-small-btn px-3 ml-3" @click="isNewProjectModalOpened = true">
                <v-icon small class="mr-2">add</v-icon>
                Nouveau chantier
              </v-btn>
              <!-- <v-badge
                color="error"
                content="4"
                overlap
                large
              >
                <v-btn class="n-white-btn n-small-btn n-icon-btn px-3 ml-3" @click="forceFetchInterventions">
                  <v-icon small class="mr-2">today</v-icon>
                  À plannifier
                </v-btn>
              </v-badge> -->
            </v-row>
            <v-row no-gutters justify="center" align="center">
              <v-spacer />
            </v-row>
            <v-row no-gutters justify="center" align="center" v-if="isFetchingDatas">
              <div style="margin-top: 20%; width: 250px;">
                <v-progress-linear
                  color="primary"
                  indeterminate
                  rounded
                  height="6"
                ></v-progress-linear>
              </div>
            </v-row>
            <div class="page-main-content" v-else>
              <n-card class="elevation-0">
                <v-row no-gutters justify="center" align="stretch">
                  <div class="workload-col-1" style="background: #FFF; border-right: 1px solid #CCC;">
                    <v-row no-gutters justify="center" align="center" class="workload-col-header" style="border-bottom: 2px solid #CCC;">
                      Chantiers
                    </v-row>
                    <div class="workload-col-content">
                      <div v-for="(project, i) in projects" :key="i" class="workload-project-line px-2 pt-1">
                        <v-row no-gutters justify="start" align="center" class="text-truncate">
                          <div class="text-truncate font-weight-medium">
                            {{ project.client.name }}
                          </div>
                        </v-row>
                        <v-row no-gutters justify="start" align="center" class="text-truncate">
                          <div class="text-truncate text--secondary">
                            <v-icon small color="grey" class="ml-1" style="margin-top: -3px;">subdirectory_arrow_right</v-icon>
                            {{ project.label }}
                          </div>
                        </v-row>
                      </div>
                    </div>
                  </div>
                  <v-col class="workload-col-2" ref="daysContent">
                    <v-row no-gutters justify="center" align="stretch" class="workload-col-grid">
                      <v-col
                        v-for="(day, i) in days"
                        :key="i"
                        class="grid-day"
                      >
                        &nbsp;
                      </v-col>
                    </v-row>
                    <div class="workload-col-header">
                      <div class="workload-col-header-line">
                        <v-row no-gutters justify="center" align="center" class="fill-height months-header">
                          <v-row
                            no-gutters
                            jusitify="center"
                            align="center"
                            v-for="(month, i) in months"
                            :key="i"
                            class="month-header text-left fill-height text-truncate"
                            :style="{
                              flexBasis: month.style.width,
                            }"
                          >
                            <div class="text-truncate">
                              {{ month.label }}
                            </div>
                          </v-row>
                        </v-row>
                      </div>
                      <div class="workload-col-header-line">
                        <v-row no-gutters justify="center" align="center" class="fill-height days-header" style="border-bottom: 2px solid #CCC;">
                          <v-col
                            v-for="(day, i) in days"
                            :key="i"
                            class="day-header"
                          >
                            {{ day.moment.format(`D`) }}
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                    <div class="workload-col-content">
                      <div v-for="(project, i) in projects" no-gutters justify="center" align="center" :key="i" class="workload-project-line" style="position: relative; overflow: hidden;">
                        <div
                          v-for="intervention in project.interventions"
                          :key="`intervention-${intervention.id}`"
                          class="project-intervention-wrapper"
                          :style="{
                            left: intervention.style.left,
                            width: intervention.style.width,
                          }"
                          @mousedown="startDragIntervention($event, intervention)"
                        >
                          <div
                            class="project-intervention"
                            :style="{
                              backgroundColor: intervention.color
                            }"
                          >
                            &nbsp;
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row no-gutters justify="center" align="center" v-if="projects.length === 0">
                  <div class="mt-12 mb-12 font-weight-bold">
                    Aucun chantier pour cette période
                  </div>
                </v-row>
              </n-card>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-row>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { mapState } from 'vuex';
import ProjectModal from '@/components/Projects/ProjectModal.vue';
import ProjectInterventionModal from '@/components/Projects/ProjectInterventionModal.vue';

export default {
  name: `Workload`,
  data: () => ({
    isFetchingProjects: false,
    isFetchingInterventions: false,
    firstMonday: moment().startOf(`isoWeek`).format(`YYYYMMDD`),
    nbWeeks: 5,
    isNewProjectModalOpened: false,
    dragInformations: null,
    projectsDragCache: [],
    projects: [],
    openedIntervention: null,
  }),
  computed: {
    ...mapState(`ui/projects`, {
      storeProjects: `projects`,
      storeInterventions: `interventions`,
    }),
    lastFriday() {
      return moment(this.firstMonday, `YYYYMMDD`).add(this.nbWeeks - 1, `weeks`).day(5).format(`YYYYMMDD`);
    },
    days() {
      const days = [];
      const day = moment(this.firstMonday, `YYYYMMDD`);
      while (day.isSameOrBefore(moment(this.lastFriday, `YYYYMMDD`))) {
        if ([0, 6].indexOf(day.day()) === -1) {
          const clonedDay = day.clone();
          days.push({
            iso: clonedDay.format(`YYYYMMDD`),
            moment: clonedDay,
          });
        }
        day.add(1, `days`);
      }
      return days;
    },
    nbDays() {
      return this.days.length;
    },
    months() {
      const months = [];

      let previousMonth = { number: -1 };
      this.days.forEach((day, i) => {
        const monthNumber = parseInt(day.moment.format(`M`), 10);
        if (monthNumber !== previousMonth.number) {
          if (previousMonth.number !== -1) {
            previousMonth.iDayEnd = i;
            previousMonth.style.width = `${((previousMonth.iDayEnd - previousMonth.iDayStart) / this.nbDays) * 100}%`;
          }
          const newMonth = {
            iDayStart: i,
            iDayEnd: this.nbDays,
            number: monthNumber,
            shortLabel: day.moment.format(`MMM`),
            label: _.upperFirst(day.moment.format(`MMMM`)),
            style: {
              left: `${(i / this.nbDays) * 100}%`,
              width: `${((this.nbDays - i) / this.nbDays) * 100}%`,
            },
          };
          months.push(newMonth);
          previousMonth = _.last(months);
        }
      });

      return months;
    },
    interventions() {
      const interventions = [];
      const from = parseInt(_.first(this.days).iso, 10);
      const to = parseInt(_.last(this.days).iso, 10);

      this.storeInterventions.forEach(intervention => {
        const plannedStartAt = parseInt(intervention.plannedStartAt, 10);
        const plannedEndAt = parseInt(intervention.plannedEndAt, 10);
        if (plannedStartAt <= to && plannedEndAt >= from) {
          // console.log(intervention.id, intervention.isMenuOpened);
          interventions.push({
            ...intervention,
            color: intervention.assignee ? intervention.assignee.color : `#AAA`,
          });
        }
      });

      return interventions;
    },
    ...mapState(`model/client`, [`company`, `clients`, `isAggregator`, `sites`]),
    ...mapState(`model/user`, [`me`, `isMakerUser`, `isAggregatorUser`]),
    ...mapState(`ui/mainLayout`, [`mouseMoveEvent`]),
    isDraggingIntervention() {
      return this.dragInformations !== null;
    },
    isFetchingDatas() {
      return this.isFetchingProjects || this.isFetchingInterventions;
    },
    isInterventionOpened: {
      get() { return this.openedIntervention !== null; },
      set() { this.openedIntervention = null; },
    },
  },
  methods: {
    computeProjects() {
      let projects = [];
      const sourceProjects = this.isDraggingIntervention ? this.projectsDragCache : this.storeProjects;

      sourceProjects.forEach(project => {
        const interventions = _.filter(this.interventions, { Project_id: project.id }).map(this.computeInterventionStyle);
        const sortedInterventions = _.sortBy(interventions, `plannedStartAt`);
        if (interventions.length) {
          projects.push({
            ...project,
            interventions: sortedInterventions,
            firstPlannedStart: _.first(sortedInterventions).plannedStartAt,
            lastPlannedEnd: _.last(sortedInterventions).plannedEndAt,
          });
        }
      });

      if (!this.isDraggingIntervention) {
        projects = _.sortBy(projects, [`firstPlannedStart`, `lastPlannedEnd`]);
      }

      this.projectsDragCache = projects;

      this.projects = projects;
    },
    computeInterventionStyle(intervention) {
      const leftIndex = _.findIndex(this.days, { iso: intervention.plannedStartAt });
      let rightIndex = _.findIndex(this.days, { iso: intervention.plannedEndAt });
      if (rightIndex === -1) {
        rightIndex = this.nbDays + 1;
      } else {
        rightIndex += 1;
      }
      const style = {
        left: `${(leftIndex / this.nbDays) * 100}%`,
        width: `${((rightIndex - leftIndex) / this.nbDays) * 100}%`,
      };
      return {
        ...intervention,
        style,
      };
    },
    previousWeek() {
      this.firstMonday = moment(this.firstMonday, `YYYYMMDD`).subtract(1, `week`).format(`YYYYMMDD`);
      this.fetchInterventions();
    },
    nextWeek() {
      this.firstMonday = moment(this.firstMonday, `YYYYMMDD`).add(1, `week`).format(`YYYYMMDD`);
      this.fetchInterventions();
    },
    async fetchProjects() {
      this.isFetchingProjects = true;
      await this.$store.dispatch(`ui/projects/fetchProjects`);
      this.isFetchingProjects = false;
    },
    async fetchInterventions() {
      this.isFetchingInterventions = true;
      const from = this.firstMonday;
      const to = this.lastFriday;
      await this.$store.dispatch(`ui/projects/fetchInterventions`, { from, to });
      this.isFetchingInterventions = false;
    },
    async fetchDatas() {
      this.fetchProjects();
      this.fetchInterventions();
    },
    projectCreated() {
      this.fetchDatas();
    },
    openInterventionMenu(intervention) {
      this.openedIntervention = intervention;
    },
    interventionUpdated() {},
    startDragIntervention(evt, intervention) {
      evt.preventDefault();
      const dayWidth = this.$refs.daysContent.offsetWidth / (this.nbWeeks * 5);
      this.dragInformations = {
        dayWidth,
        intervention,
        startEvent: evt,
        diffX: 0,
        hasDragged: false,
      };
      // console.log(`start drag`);
    },
    mouseMoved(evt) {
      if (this.dragInformations !== null) {
        const diffX = evt.clientX - this.dragInformations.startEvent.clientX;
        if (diffX !== this.dragInformations.diffX) {
          this.dragInformations = {
            ...this.dragInformations,
            diffX,
            hasDragged: this.dragInformations.hasDragged || Math.abs(diffX) > this.dragInformations.dayWidth / 4,
          };
        }
        // console.log(evt);
      }
    },
    dropIntervention(evt) {
      if (!this.dragInformations) { return; }
      const interventionId = this.dragInformations.intervention.id;
      const intervention = _.find(this.interventions, { id: interventionId });
      const isUpdated = parseInt(intervention.plannedStartAt, 10) !== parseInt(this.dragInformations.intervention.plannedStartAt, 10);
      const isDroppedOnSameThanStart = evt.target === this.dragInformations.startEvent.target;
      if (isUpdated) {
        this.$store.dispatch(`ui/projects/updateIntervention`, interventionId);
        setTimeout(() => this.computeProjects()); // Let time to set dragInformations to null before computing
      } else if (isDroppedOnSameThanStart && !this.dragInformations.hasDragged) {
        this.openInterventionMenu(intervention);
      }
      this.dragInformations = null;
    },
    // updateInterventionLocally(intervention) {
    //   const interventionIndex = _.findIndex(this)
    // },
    isAllowedDate(date) {
      return !_.includes([0, 6], date.day());
    },
    addDaysToDate(date, nbDays) {
      const updatedDate = date.clone();
      const nbDaysAbs = Math.abs(nbDays);
      // const inc = nbDays > 0 ? 1 : -1;
      const method = nbDays > 0 ? `add` : `subtract`;
      for (let index = 0; index < nbDaysAbs; index += 1) {
        do {
          updatedDate[method](1, `days`);
        } while (!this.isAllowedDate(updatedDate));
      }

      return updatedDate;
    },
  },
  async beforeMount() {
    this.fetchDatas();
  },

  components: {
    ProjectModal,
    ProjectInterventionModal,
  },

  watch: {
    dragInformations(dragInformations) {
      if (dragInformations !== null) {
        const { intervention } = dragInformations;
        const nbDaysDiff = Math.round(dragInformations.diffX / dragInformations.dayWidth);

        let newStartAt = this.addDaysToDate(moment(dragInformations.intervention.plannedStartAt, `YYYYMMDD`), nbDaysDiff);
        let newEndAt = this.addDaysToDate(newStartAt, intervention.plannedDaysDuration - 1);

        const firstMonday = moment(this.firstMonday, `YYYYMMDD`);
        const lastFriday = moment(this.lastFriday, `YYYYMMDD`);

        if (newEndAt.isBefore(firstMonday)) {
          newEndAt = firstMonday;
          newStartAt = this.addDaysToDate(newEndAt, -(intervention.plannedDaysDuration - 1));
        } else if (newStartAt.isAfter(lastFriday)) {
          newStartAt = lastFriday;
          newEndAt = this.addDaysToDate(newStartAt, intervention.plannedDaysDuration - 1);
        }

        this.$store.dispatch(`ui/projects/updateInterventionLocally`, {
          ...intervention,
          plannedStartAt: newStartAt.format(`YYYYMMDD`),
          plannedEndAt: newEndAt.format(`YYYYMMDD`),
        });
      }
    },
    storeInterventions() {
      this.computeProjects();
    },
    storeProjects() {
      this.computeProjects();
    },
  },
};
</script>

<style lang="scss">
$workloadHeaderLineHeight: 35px;
$workloadHeaderFullHeight: $workloadHeaderLineHeight * 2;

.workload-col-1 {
  width: 200px;
}

.workload-col-1,
.workload-col-2 {
  position: relative;
}

.workload-col-header {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: $workloadHeaderFullHeight;
  color: #333;
  font-weight: 500;

  .workload-col-header-line {
    height: $workloadHeaderLineHeight;
  }
}

.workload-col-content {
  // position: absolute;
  // top: 80px;
  // right: 0;
  // bottom: 0;
  // left: 0;
  position: relative;
  margin-top: $workloadHeaderFullHeight;
  // background-color: purple;
}

.workload-col-grid {
  position: absolute;
  top: $workloadHeaderLineHeight;
  right: 0;
  bottom: 0;
  left: 0;
  // background-color: pink;

  .grid-day {
    &:nth-child(odd) {
      background-color: #FFF;
    }
    &:nth-child(even) {
      background-color: #ebefff;
      // background-color: #E8E8E8;
    }
  }
}

.workload-project-line {
  height: 55px;
  &:not(:last-of-type) {
    border-bottom: 1px solid #CCC;
  }
}

.project-intervention-wrapper {
  position: absolute;
  top: 50%;
  margin-top: -10px;
  height: 20px;

  .project-intervention {
    position: absolute;
    cursor: pointer;
    height: 100%;
    left: 2px;
    right: 2px;
    background-color: #1d80e4;
    border-radius: 10px;
  }
}

.months-header {
  position: relative;
  // border-top: 1px solid #777;
  // border-left: 1px solid #777;
  // border-right: 1px solid #777;
  // border-top-left-radius: 8px;
  // border-top-right-radius: 8px;
  .month-header {
    // position: absolute;
    padding: 0px 6px;
    font-size: 0.9rem;
    font-weight: 500;
    // height: 25px;
    border-bottom: 1px solid #E8E8E8;
    &:not(:first-of-type) {
      margin-left: -1px;
      margin-right: 1px;
      border-left: 1px solid #E8E8E8;
    }
  }
}

.workload-project-label {
  font-size: 0.9rem;
  font-weight: 500;
  color: #444;
}

.days-header {
  position: relative;
  .day-header {
    font-weight: 500;
    font-size: 0.7rem;
    // &:not(:first-of-type) {
    //   border-left: 1px solid #777;
    // }
  }
}

.filter-item-title {
  font-weight: 500;
}

.filter-item-content-list {
  padding-top: 6px;
  & > a {
    padding: 6px 4px;
    display: block;
    color: #333 !important;
    font-size: 0.9rem;
    &:hover {
      background-color: #EEE;
    }
    &.selected {
      background-color: #2226ca;
      font-weight: 500;
      color: #FFF !important;
    }
  }
}

.workload-action-select {
  max-width: 425px;
  .v-input__prepend-inner {
    padding-right: 8px !important;
    .v-icon {
      font-size: 20px;
    }
  }
  .v-select__slot {
    // padding-right: 28px;
    .v-select__selection {
      max-width: 100% !important;;
    }
  }
  input[type=text] {
    width: 1px !important;
    flex: none;
  }
}

@media only screen and (max-width: 1260px) {
  .workload-action-select {
    max-width: 320px;
  }
}

</style>
